import React, { useCallback } from 'react';
import classNames from 'classnames';
import './PanelToggler.less';
import { ITab, Tabs } from 'components/tabs/Tabs';

export interface IPanelTooglerProps {
  tabs: ITab[];
  selectedTab?: string | null;
  onTabSelected: (tab: string | null) => void;
  align: Align;
}

export enum Align {
  left,
  right,
}

function getTabClassName(tab: ITab, selectedTab: string | null | undefined, allign: Align) {
  return classNames('dpc-panel-toggler__tab', {
    'dpc-panel-toggler__tab--left': allign === Align.left,
    'dpc-panel-toggler__tab--right': allign === Align.right,
    'dpc-panel-toggler__tab--selected': tab.value === selectedTab,
    'dpc-panel-toggler__tab--disabled': tab.disabled,
  });
}

function getTooglerClassName(selectedTab: string | null | undefined, allign: Align) {
  return classNames('dpc-panel-toggler', {
    'dpc-panel-toggler--selected': !!selectedTab,
    'dpc-panel-toggler--left': allign === Align.left,
    'dpc-panel-toggler--right': allign === Align.right,
  });
}

function getRotareClassName(allign: Align) {
  return classNames('dpc-panel-toggler__tabs', {
    'dpc-panel-toggler__tabs--left': allign === Align.left,
    'dpc-panel-toggler__tabs--right': allign === Align.right,
  });
}

export function PanelToggler({ tabs, selectedTab, onTabSelected, align }: IPanelTooglerProps) {
  const handleTabClick = useCallback(
    (tab: string) => {
      if (selectedTab !== tab) {
        onTabSelected(tab);
      } else {
        onTabSelected(null);
      }
    },
    [onTabSelected, selectedTab]
  );

  return (
    <div className={getTooglerClassName(selectedTab, align)}>
      <Tabs
        className={getRotareClassName(align)}
        onTabSelected={handleTabClick}
        currentValue={selectedTab}
        tabs={tabs}
        renderTab={tab => (
          <button key={tab.value} className={getTabClassName(tab, selectedTab, align)} disabled={tab.disabled}>
            {tab.label ?? tab.value}
          </button>
        )}
      />
    </div>
  );
}
